import React, { FC, useContext } from 'react';

import { H3, Select } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from './ShellLanguage.module.scss';
export const ShellLanguage: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings, isLoading },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <div className={s.container}>
      <H3>{t('setting.shell.lang')}</H3>
      <span className={s.subtitle}>{t('settings.shell.lang.description')}</span>
      <Select
        name="lang"
        options={[
          { title: 'Русский', value: 'RU' },
          { title: 'English', value: 'EN' },
          { title: 'Tiếng Việt', value: 'VI' },
          { title: 'Español', value: 'ES' },
          { title: 'Қазақша', value: 'KZ' },
          { title: 'O‘zbekcha', value: 'UZ' },
          { title: 'Кыргыз', value: 'KY' },
          { title: 'Azərbaycan', value: 'AZ' },
          // { title: 'Português', value: 'pt-BR', disabled: true },
          { title: 'Français', value: 'FR' },
        ]}
        value={settings.shellLanguage}
        onChange={(value) => {
          if (value === settings.shellLanguage) return;

          return setSetting({
            alias: ESettingsAliases.SHELL_LANGUAGE,
            value,
          });
        }}
        placeholder={t('language')}
        disabled={isLoading}
        disableClear
        bordered
      />
    </div>
  );
};
